import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Components/Home/Home';
import Contact from './Components/Contact/Contact';
import Fanlar from './Components/Fanlar/Fanlar';
import Haqida from './Components/Haqida/Haqida'; 
import Hodimlar from './Components/Hodimlar/Hodimlar';
import Ramzlar from './Components/Ramzlar/Ramzlar';
import Header from './Components/Header/Header';
import  Footer  from './Components/Footer/Footer'; 
function App() {
  return ( 
    <BrowserRouter>
    <div className="App"> 
        <Header />  
        <div>
            <Routes>
              <Route path={'/fanlar'} element={<Fanlar />}/>
              <Route path={''} element={<Home />}/>
              <Route path={'/contact'} element={<Contact/>}/>
              <Route path={'/fanlar'} element={<Fanlar />}/>
              <Route path={'/haqida'} element={<Haqida />}/>
              <Route path={'/hodimlar'} element={<Hodimlar />}/>
              <Route path={'/ramzlar'} element={<Ramzlar />}/>
            </Routes>
        </div>
        <Footer />
    </div>
    </BrowserRouter>
  );
}

export default App;